export default "__VITE_ASSET__DKSqC2rU__"